import { gql, QueryHookOptions } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { Nullish } from 'utils/tsHelpers';

type CurrentProject = {
  showRevenue: boolean;
  insightsFilters: string;
  groupRecurringCampaigns: boolean;
  useDynamicSenders: boolean;
  enableAnonUserTracking: boolean;
};

type QueryCurrentProjectResponse = { currentProject?: Nullish<CurrentProject> };
type QueryCurrentProjectOptions = QueryHookOptions<QueryCurrentProjectResponse>;

export const queryCurrentProjectQuery = gql`
  {
    currentProject {
      showRevenue
      insightsFilters
      groupRecurringCampaigns
      useDynamicSenders
      enableAnonUserTracking
    }
  }
`;

export const useCurrentProject = (options?: QueryCurrentProjectOptions) => {
  const {
    data,
    isLoading,
    errorMessage,
    error: hasError = false,
    refetch,
  } = useGraphql<QueryCurrentProjectResponse>(queryCurrentProjectQuery, options);

  return {
    projectSettings: data?.currentProject,
    isLoading,
    error: errorMessage,
    hasError,
    refetch,
  };
};
